import React, { useEffect, useState } from 'react';
import './testimonial.css';

const imageList = [
    "/images/Pramod.png",
    "/images/Manu.JPG",
    "/images/Kanika.jpg",
    "/images/Ashish.jpg",
    "/images/Sanika.jpg",
    "/images/suchi.jpeg",
    "/images/Shreevatsa.jpg"
];

const Testimonial = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        fetch('/basic.csv')
            .then(res => res.text())
            .then(text => {
                const lines = text.trim().split('\n');
                const headers = lines[0].split(',');
                const get = (row, key) => row[headers.indexOf(key)]?.replace(/^"|"$/g, '').trim();
                const data = lines.slice(1)
                    .map(line => {
                        // Handle quoted commas
                        const row = [];
                        let current = '';
                        let inQuotes = false;
                        for (let i = 0; i < line.length; i++) {
                            const char = line[i];
                            if (char === '"') inQuotes = !inQuotes;
                            else if (char === ',' && !inQuotes) {
                                row.push(current);
                                current = '';
                            } else {
                                current += char;
                            }
                        }
                        row.push(current);
                        return {
                            testimonial: get(row, 'Testimonial'),
                            name: get(row, 'Name'),
                            org: get(row, 'org title'),
                            role: get(row, 'Role')
                        };
                    })
                    .filter(t => t.testimonial && t.name);
                setTestimonials(data);
            });
    }, []);

    const totalDots = testimonials.length;

    // Circular scroll animation
    const handlePrev = () => {
        setActiveIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
    };

    const handleNext = () => {
        setActiveIndex(prev => (prev + 1) % testimonials.length);
    };

    // Auto-scroll effect (circular)
    useEffect(() => {
        if (!testimonials.length) return;
        const interval = setInterval(() => {
            setActiveIndex(prev => (prev + 1) % testimonials.length);
        }, 4000);
        return () => clearInterval(interval);
    }, [testimonials]);

    if (!testimonials.length) return null;

    return (
        <div className="testimonial-section">
            {/* <h2 className="testimonial-title">Hear From the Past DMP Contributors</h2> */}
            <div className="testimonial-carousel">
                {testimonials.map((testimonial, idx) => {
                    let position = 'hidden';
                    if (idx === activeIndex) position = 'active';
                    else if ((idx === (activeIndex + 1) % testimonials.length)) position = 'next';
                    else if ((idx === (activeIndex - 1 + testimonials.length) % testimonials.length)) position = 'prev';

                    // Use image from imageList by index, fallback to first image if out of range
                    const imgSrc = imageList[idx] || imageList[0];

                    return (
                        <div
                            className={`testimonial-card testimonial-card-${position}`}
                            key={idx}
                        >
                            <div className="quote-top-wrapper">
                                <img src="/images/pic2.png" alt="quote" className="quote-img" />
                            </div>
                            <div className="testimonial-left">
                                <div className="testimonial-img-wrapper">
                                    <img
                                        src={imgSrc}
                                        alt="Contributor"
                                        className="testimonial-img"
                                    />
                                </div>
                            </div>
                            <div className="testimonial-right">
                                <div className="testimonial-text">
                                    <em>{testimonial.testimonial}</em>
                                </div>
                                <div className="testimonial-author">
                                    <span className="testimonial-name">{testimonial.name}</span>
                                    {testimonial.org && (
                                        <span className="testimonial-role">{testimonial.org}</span>
                                    )}
                                    {testimonial.role && (
                                        <span className="testimonial-role">{testimonial.role}</span>
                                    )}
                                </div>
                            </div>
                            <div className="quote-bottom-wrapper">
                                <img src="/images/pic2.png" alt="quote" className="quote-img rotated" />
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="testimonial-scroll-indicators">
                <span className="testimonial-arrow" onClick={handlePrev}>&larr;</span>
                {Array.from({ length: totalDots }).map((_, idx) => (
                    <span
                        key={idx}
                        className={`testimonial-dot${activeIndex === idx ? ' active' : ''}`}
                        onClick={() => setActiveIndex(idx)}
                    ></span>
                ))}
                <span className="testimonial-arrow" onClick={handleNext}>&rarr;</span>
            </div>
        </div>
    );
};

export default Testimonial;